import React from "react";
import ReactDOM from "react-dom";
import App from "./App/index";
import { Provider } from "react-redux";
import { Store } from "./store";
import { MuiThemeProvider, createTheme  } from "@material-ui/core/styles";

const theme = createTheme ({
  palette: {
    primary: {
      main: "#0093DD",
    },
  },
  typography: {
    useNextVariants: true,
  },
});

ReactDOM.render(
  <Provider store={Store}>
    <MuiThemeProvider theme={theme}>
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById("root")
);
